export default "__VITE_ASSET__gyIzTkRM__"